import React, { useEffect, useState } from 'react';
import { AlertTriangle, ChevronDown, History } from 'lucide-react';
import api from '../../utils/axios';

const fecha = (f) => (f ? new Date(f).toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '—');
const valor = (v) => (v === null || v === undefined ? '—' : Number(v).toLocaleString('es-AR'));

// H2: "Última revisión: <fecha> por <usuario>", aviso a los 180 días, motivo del cambio e historial de valores.
export const RevisionUmbrales = ({ entidad, entidadId, motivo, onMotivo }) => {
  const [rev, setRev] = useState(null);
  useEffect(() => {
    if (!entidadId) return undefined;
    let vivo = true;
    api.get('/umbrales/revision', { params: { entidad, entidad_id: entidadId } })
      .then((r) => vivo && setRev(r.data)).catch(() => vivo && setRev(null));
    return () => { vivo = false; };
  }, [entidad, entidadId]);

  if (!rev) return null;
  return (
    <div className="space-y-2 rounded-lg border border-slate-200 bg-slate-50 p-3 text-xs" data-testid="revision-umbrales">
      <p className="text-slate-600" data-testid="revision-ultima">
        {rev.ultima_revision
          ? <>Última revisión: <strong>{fecha(rev.ultima_revision.fecha)}</strong> por <strong>{rev.ultima_revision.por}</strong></>
          : 'No hay valores numéricos para revisar.'}
      </p>
      {rev.aviso && (
        <p className="flex items-start gap-1.5 rounded-md bg-amber-100 px-2 py-1.5 text-amber-900" data-testid="revision-aviso">
          <AlertTriangle size={13} className="mt-0.5 shrink-0" />
          Pasaron más de {rev.dias_aviso} días sin revisar: {rev.vencidos.join(', ')}.
        </p>
      )}
      {onMotivo && (
        <input value={motivo || ''} onChange={(e) => onMotivo(e.target.value)} data-testid="revision-motivo"
          placeholder="Motivo del cambio (obligatorio si cambiás algún valor; queda en el historial)"
          className="h-8 w-full rounded-md border border-slate-200 bg-white px-2 text-xs focus:outline-none focus:ring-2 focus:ring-sky-200" />
      )}
      {rev.historial.length > 0 && (
        <details className="group" data-testid="revision-historial">
          <summary className="flex cursor-pointer items-center gap-1 font-medium text-slate-600">
            <ChevronDown size={12} className="transition-transform group-open:rotate-180" /><History size={12} /> Historial de valores ({rev.historial.length})
          </summary>
          <ol className="mt-2 max-h-40 space-y-1 overflow-y-auto">
            {rev.historial.map((h) => (
              <li key={h.id} className="rounded bg-white px-2 py-1" data-testid={`revision-historial-${h.id}`}>
                <span className="font-medium text-slate-700">{h.etiqueta}</span>: {valor(h.valor_anterior)} → <strong>{valor(h.valor_nuevo)}</strong>
                <span className="text-slate-400"> · {fecha(h.fecha)} por {h.usuario}{h.motivo ? ` · ${h.motivo}` : ''}</span>
                <span className="block text-[10px] text-slate-400">Valor anterior revisado el {fecha(h.fecha_revision_anterior)} por {h.revisado_por_anterior}</span>
              </li>
            ))}
          </ol>
        </details>
      )}
    </div>
  );
};

export default RevisionUmbrales;
